import { render, staticRenderFns } from "./AdminHeader.vue?vue&type=template&id=5083aed8&scoped=true&"
import script from "./AdminHeader.vue?vue&type=script&lang=ts&"
export * from "./AdminHeader.vue?vue&type=script&lang=ts&"
import style0 from "./AdminHeader.vue?vue&type=style&index=0&id=5083aed8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5083aed8",
  null
  
)

export default component.exports